import { useContext } from 'react';
import { useSelector } from 'react-redux';

import { EnrollmentContext } from '@modules/members/enrollments/context/MemberMyEnrollmentProvider';

const useValidateAPTCAmount = () => {
    const permissions = useSelector((state: any) => state.memberEnrollment?.permissions);
    const { isMinimumPremiumGlobalPropertyValueAvailable, minimumPremiumGlobalPropertyValue } = permissions || {};
    const { enableContinueButton, enrollmentPremiumFormContext, selectedEnrollment } = useContext(EnrollmentContext);
    const { setValue } = enrollmentPremiumFormContext;

    return premiumData => {
        const premium = { ...premiumData };
        enableContinueButton();

        premium.netPremiumAmount = Number(premium.grossPremiumAmount);

        if (premium.aptcAmount !== undefined && premium.aptcAmount !== null) {
            const netPremiumAfterAptc = premium.netPremiumAmount - (Number(premium.aptcAmount) || 0);
            if (netPremiumAfterAptc < premium.minimumPremium) {
                premium.aptcAmount = premium.grossPremiumAmount - premium.minimumPremium;
                premium.netPremiumAmount = premium.minimumPremium;
            } else {
                premium.netPremiumAmount = netPremiumAfterAptc;
            }
        }

        if (premium.stateSubsidyAmount !== undefined || premium.stateSubsidyAmount !== null) {
            premium.netPremiumAmount = Number(premium.netPremiumAmount) - (Number(premium.stateSubsidyAmount) || 0);
        }
        if (premium.statePremiumCreditAmt !== undefined) {
            if (premium.netPremiumAmount - premium.statePremiumCreditAmt < 0) {
                premium.netPremiumAmount = 0;
            } else {
                premium.netPremiumAmount = premium.netPremiumAmount - premium.statePremiumCreditAmt;
            }
        }

        if (premium?.isMedicaidTransitionEligible) {
            const medicaidTransitionAmount =
                premium.grossPremiumAmount -
                ((Number(premium.aptcAmount) || 0) +
                    (Number(premium.stateSubsidy2Amount) || 0) +
                    (Number(premium.stateSubsidyAmount) || 0) +
                    (Number(premium.maxAptc) || 0) -
                    (Number(premium.aptcAmount) || 0));
            premium.medicaidTransitionAmount = medicaidTransitionAmount < 0 ? 0 : medicaidTransitionAmount;
            setValue(
                `enrollmentPremiumDtoList.${premium.month - 1}.medicaidTransitionAmount`,
                premium.medicaidTransitionAmount,
                {
                    shouldDirty: true,
                    shouldValidate: true,
                },
            );
        }
        premium.netPremiumAmount = Number(parseFloat(premium?.netPremiumAmount).toFixed(2) || 0);

        setValue(`enrollmentPremiumDtoList.${premium.month - 1}.netPremiumAmount`, premium.netPremiumAmount, {
            shouldDirty: true,
            shouldValidate: true,
        });
    };
};

export default useValidateAPTCAmount;
